/**
 * localStorage 키는 앱 접두어로 네임스페이스한다 (설계 §2-2(6)).
 * 같은 오리진에 다른 페이스콕 앱이 배포될 수 있어 전역 키를 쓰지 않는다.
 */
const PREFIX = 'fc-gym-admin'

export const STORAGE_KEYS = {
  accessToken: `${PREFIX}:accessToken`,
  refreshToken: `${PREFIX}:refreshToken`,
  accessTokenExpiresAt: `${PREFIX}:accessTokenExpiresAt`,
  refreshTokenExpiresAt: `${PREFIX}:refreshTokenExpiresAt`,
  /** 로그아웃해도 남긴다 — 서버 refresh 행 키가 `(memberId, deviceId)` 라 재사용한다. */
  deviceId: `${PREFIX}:deviceId`,
  /** 로그아웃해도 남긴다 — 재로그인 시 마지막 구장으로 되돌리는 편의값. */
  lastVenueId: `${PREFIX}:lastVenueId`,
  /** 톱바 표시용 로그인 아이디. 인증 판정에 쓰지 않는다. */
  loginId: `${PREFIX}:loginId`,
} as const
